module.exports = __webpack_public_path__ + "static/media/calendar.fa4a6b88.svg";